export const addOnsData = [
    {
        id: 1,
        title: 'Online service',
        feature: 'Access to multiplayer games',
        monthlyFee: 1,
        yearlyFee: 10,
        selected: false
    },

    {
        id: 2,
        title: 'Larger Storage',
        feature: 'Extra 1TB of cloud save',
        monthlyFee: 2,
        yearlyFee: 20,
        selected: false
    },

    {
        id: 3,
        title: 'Customizable profile',
        feature: 'Custom theme on your profile',
        monthlyFee: 2,
        yearlyFee: 20,
        selected: false
    }
]